import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

// select tag options keyed by id
export const selectTagOptionsData = createSelector(
  [(state: ApplicationState) => state.TagOptionStore.data],
  (data) => data
)

export const selectTagOptionsFetched = createSelector(
  [(state: ApplicationState) => state.TagOptionStore.fetched],
  (fetched) => fetched
)
